import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
    container: {
        '@media (min-width: 768px)': {
            width: '768px',
        },
        backgroundColor: theme.colors.dark.dark1,
        padding: '0 16px 16px 16px',
    },
    headline: {
        ...theme.typographyPresets.titleSmallBold,
        ...theme.fontColors.light,
        paddingTop: '50px',
        marginBottom: '48px',
    },
    question: {
        marginTop: '100px',
    },
    submitBtn: {
        marginTop: '60px',
    },
}))
